import React, { useEffect, useRef, useState, FC } from 'react'
import { Button, Form, message, Modal, Upload } from 'antd'
import { YhFormBox } from '@/components/YhFormBox'
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef, ISelectOption } from '@/components/YhFormBox/Types'
import useNavModel, { RouterParamType } from '@/model/navModel'
import { getFormValidatorErrText, switchNum1, formatNum } from '@/utils/utils'
import { ITreeSelectData, useDictModel } from '@/views/base/dict/dictModel'
import { useAssetsInventoryDetailsModel } from './assetsInventoryDetailsModel'
import { ISCMAssetsInventoryFormFields } from '../../assetsInventoryTypes'
import useGlobalModel from '@/model/globalModel'
import { YhAuth } from '@/components/auth/YhAuth'
import { debounce } from 'lodash'
import { assetsInventoryService } from '../../assetsInventoryService'
import { ResourceAuthEnum } from '@/types/AppResourceAuthEnum'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import FontIcon from '@/components/YhIcon'
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from '@/utils/constants'
import { UploadOutlined } from '@ant-design/icons'
import { UploadChangeParam } from 'antd/lib/upload'
import { fileDownload } from '@/utils/exportFile'
import { UploadFile } from 'antd/lib/upload/interface'
import { YHDetailNav } from '@/components/YHDetailNav'
import { useOrgModel } from '@/views/base/organization/orgModel'

export const FormBox: FC<RouterParamType> = ({ id, mode }) => {
    const optionsList: [] = []
    const formRef = useRef<IYhFormRef>()
    const {
        editFormVal,
        addFormVal,
        buttonControl,
        saveBtnLoading,
        saveBtn,
        addGoodsList,
        setPrint,
        insertSDc,
        updateSDc,
        getSDcDetailOne,
        updateEditFormVal,
        updateAddFormVal,
        resetEditCatch,
        resetAddCatch,
        verifyGoods,
        setSaveBtnLoading,
        setMaterialCodeVisible,
        setChangeImport,
        setAddGoodsList,
    } = useAssetsInventoryDetailsModel()
    const { selectedNavId, replaceNav, findNav } = useNavModel()
    const { getSelectedDictOne } = useDictModel(() => [])
    const { getOrgTreeSelect } = useOrgModel(() => [])

    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            !findNav('3-1-1') && resetAddCatch()
            !findNav('3-1-2') && resetEditCatch()
        }
    }, [selectedNavId])

    //编辑时， 没有缓在调用详情接口    //回显对应门店核算单位的实体
    useEffect(() => {
        if (mode !== 'add') {
                getSDcDetailOne(id)
                return
        }
    }, [mode])
    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }, isFormItem: boolean = true) => {
        mode === 'edit' ? updateEditFormVal(val) : updateAddFormVal(val)
    }

    //表单change
    const onChange = (changedValues: { [key: string]: any }, values: any) => {
        saveCache(changedValues)
    }

    //机构选中
    const onDepartmentChange = (value: string, node: ITreeSelectData) => {
        node && saveCache({ departmentName: node.title,department: node.value, })
        setChangeImport(false)
        if(addGoodsList.length>0){
            setAddGoodsList([])
        }
    }
    //表单提交
    const onSubmit = () => {
        if (!verifyGoods(mode)) return
        
        formRef.current
            ?.validateFields()
            .then((val: any) => {
                mode === 'edit'? updateSDc(val): insertSDc(val).then((res) => {
                          if (res) {
                              replaceNav(selectedNavId, '3-1')
                              setSaveBtnLoading(false)
                          }
                      })
            })
            .catch((err) => {
                message.warning(getFormValidatorErrText(err))
            })
    }
    const onCheck = () => {
        getSDcDetailOne(editFormVal.id)
        setMaterialCodeVisible(true)
    }
    const action = (
        <>
            {mode=='look'&&<Button
                className="mr-5"
                type="link"
                shape="round"
                loading={saveBtnLoading}
                onClick={onCheck}
            >
                盘点差异
            </Button>}
            <YhAuth resCode={ResourceAuthEnum.ASSETS_ST_STTAKE_ED_SAVE}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                loading={saveBtnLoading}
                onClick={debounce(() => {
                    onSubmit()
                }, 500)}
                disabled={mode=='look'}
            >
                {saveBtnLoading ? '保存中' : '保存'}
            </Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.ASSETS_ST_STTAKE_ED_BACK}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    replaceNav(selectedNavId, '3-1')
                    setSaveBtnLoading(false)
                }}
            >
                返回
            </Button>
            </YhAuth>
        </>
    )




    const baseFormItem: IYhFormItemsBox = {
        title: '基础信息',
        style: { padding: '10px 0 0 0', marginBottom: '15px' },
        contentClass: 'pr-77',
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '盘点单号',
                fieldName: 'stocktakingCode',
                disable: true,
                placeholder: '自动生成',
            },
            {
                type: FormItemTypeEnum.TreeSelect,
                fieldLabel: '盘点部门',
                fieldName: 'department',
                onTreeSelectChange:onDepartmentChange,
                treeData: getOrgTreeSelect(DictCodeEnmu.ORG),
                rules: [{ required: true, message: '请选择盘点部门' }],
            },
            // {
            //     type: FormItemTypeEnum.Select,
            //     fieldLabel: '盘点类型',
            //     fieldName: 'type',
            //     options: getSelectedDictOne(DictCodeEnmu.RECEIVE_TYPE),
            //     rules: [{ required: true, message: '请选择盘点类型' }],
            // },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: '开始时间',
                fieldName: 'startTime',
            },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: '结束时间',
                fieldName: 'endTime',
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "盘点人",
                fieldName: "stocktakingUser",
                mode: "tags",
                options: optionsList,
                placeholder: '可多选，输入回车添加',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '联系电话',
                fieldName: 'stocktakingPhone',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '盘点时间',
                fieldName: 'createTime',
                disable: true,
            },
           
            // 带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入实体名称',
                fieldName: 'departmentName',
                hidden: true,
            },
        ],
    }

    const poFromConfig: IYhFormBox<ISCMAssetsInventoryFormFields> = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: 'right',
        formValues: mode === 'add' ?addFormVal: editFormVal,
        onChange,
        boxs: [baseFormItem],
        disabled:mode=='look'
    }

    return (
        <>
            <YHDetailNav title={`${mode === 'edit' ? '编辑' :mode === 'look'?'查看': '新增'}`} btns={action} style={{ marginBottom: '8px' }} />
            <YhFormBox {...poFromConfig} />
        </>
    )
}
